import React, { useEffect, useReducer, useState } from 'react';
import AppApi from '../utils/bridge.js'
import Calendar from 'react-calendar';
import html2canvas from 'html2canvas'
import './newcalendar.scss';
import 'react-calendar/dist/Calendar.css';
import './calendar.scss';
import sun from '../img/sun.png'
import Nodata from './Nodata';
import icon8 from '../img/icon8.png'
import rank1 from '../img/rank1.png'
import rank2 from '../img/rank2.png'
import rank3 from '../img/rank3.png'
import icon6 from '../img/icon6.png'
import icon9 from '../img/icon9.png'
import icon10 from '../img/icon10.png'
import icon11 from '../img/icon11.png'
import icon12 from '../img/icon12.png'
import icon13 from '../img/icon13.png'
import icon15 from '../img/icon15.png'
import icon16 from '../img/icon16.png'
import icon17 from '../img/icon17.png'
import icon18 from '../img/icon18.png'
import icon19 from '../img/icon19.png'
import icon20 from '../img/icon20.png'
import layer_bottom from '../img/layer_bottom.png'
import NewsList from './Newlist.js'
import Personal from './Personal';
import Layer from './Layer.js';
import layer_bg from '../img/layer_bg.png'
import { getCityCode, getCityWeather, getNewsList, getJiJjian, getStock, getTodayStock, getPersonalArticle, getHotRank, getIp } from '../api/api'
const { Solar, Lunar, HolidayUtil } = require('lunar-javascript')

function getWeek(params) {
    let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    return weeks[params]
}


function Newcalendar() {
    let u = navigator.userAgent;
    const [isApp, setIsApp] = useState(u.includes('nbd'));
    const [date, setDate] = useState(new Date());
    const [lunar, setLunar] = useState();
    // const [map, setMap] = useState({})
    const [city, setCity] = useState()
    const [adCode, setadCode] = useState()
    const [weather, setWeather] = useState({ weather: '' })
    const [isSlide, changeSlie] = useState(false);
    const [calendarTop, setCalendarTop] = useState()
    const [activeIndex, setActiveIndex] = useState(0)
    const [newsList, setNewsList] = useState([])
    const [jiJian, setJiJian] = useState({ qingxu: {}, zhangDie: {}, jiejin: {} })
    const [stockList, setStockList] = useState([])
    const [todayStock, setTodayStock] = useState([])
    const [hotRank, setHotRank] = useState([])
    const [previewImg, setPreviewImg] = useState([])
    const [startImg, setStartImg] = useState(false)
    const [isShowLayer, setIsShowLayer] = useState(false)

    const tabList = isApp ? ['今日大事', '私人订制'] : ['今日大事']
    const isShow = (ishow) => {
        setIsShowLayer(ishow)
    }
    const closeImg = () => {
        setStartImg(false)
    }
    const shareInfo = () => {
        let year = new Date().getFullYear()
        let mon = new Date().getMonth() + 1
        let day = new Date().getDate()
        AppApi.share({
            share_digest: '收藏！一览2023年财经大事件，抢先了解全球重磅资讯',
            share_image: "http://static.nbd.com.cn/images/app/nbd_icon_300_normal.png",
            share_title: year + '年' + mon + '月' + day + '日' + ' 每经日历',
            share_url: 'https://www.nbd.com.cn/corp/NBDCalendar/build/index.html'
        })
    }

    const openLink = (url) => {
        AppApi.open_link({
            url: url,
            show_title_bar: true
        })
    }
    const WeatherIcon = () => {

        if (weather.weather.includes('晴')) {
            return <img src={icon16} className='u-weather-icon' />
        } else if (weather.weather.includes('雨')) {
            return <img src={icon18} className='u-weather-icon' />
            // return icon18
        } else if (weather.weather.includes('云')) {
            return <img src={icon17} className='u-weather-icon' />
            // return 'icon17'
        } else if (weather.weather.includes('雷')) {
            return <img src={icon19} className='u-weather-icon' />
            // return icon19
        } else {
            return null
        }

    }

    const switchInex = (index) => {
        setActiveIndex(index)
    }


    const titleControl = (a, b) => {
        AppApi.title_control({
            hide_action_bar: a,
            hide_more: b
        })
    }

    const changeSlide = () => {
        changeSlie(!isSlide)
        if (!isSlide) {
            // console.log('123213')
            document.getElementsByClassName('react-calendar__month-view__days')[0].style.top = '0px'
        } else {
            document.getElementsByClassName('react-calendar__month-view__days')[0].style.top = -calendarTop + 'px'
        }
    }
    const changeDate = (change_date) => {
        console.log(change_date)





        setDate(change_date)
        getNewsList({
            date: change_date.getFullYear() + '-' + Number(change_date.getMonth() + 1) + '-' + change_date.getDate()
        }).then(res => {
            // setFilter('全部')
            // console.log(res.data.events[0].events)
            // setFilterNews(res.data.events[0].events )
            setNewsList(res.data.events[0].events)
        })
    }


    const getNews = () => {
        getNewsList({
            date: date.getFullYear() + '-' + Number(date.getMonth() + 1) + '-' + date.getDate()
        }).then(res => {
            console.log(res)
            setNewsList(res.data.events[0].events)
        })
    }

    const canvasImg = () => {
        setStartImg(true)
        setIsShowLayer(false)
        html2canvas(document.getElementById('bg'), {
            backgroundColor: null,
            useCORS: true,
            allowTaint: true,
            dpi: window.devicePixelRatio * 2.5
        }).then((canvas) => {
            let url = canvas.toDataURL("image/png");

            // canvas.toBlob(function(blob){
            //     let new_url = URL.createObjectURL(blob);
            //     console.log(new_url)
            // })
            setPreviewImg(url)
            console.log(url)
        });
    }

    const disabledDate = (activeStartDate, date, view) => {
        console.log(activeStartDate)
        console.log(view)
        console.log(date)
    }

    useEffect(() => {
        // var map = new BMapGL.Map("container");
        // var point = new BMapGL.Point(116.331398, 39.897445);
        // map.centerAndZoom(point, 12);
        // var geolocation = new BMapGL.Geolocation();
        // geolocation.getCurrentPosition(function (r) {
        //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        //         var mk = new BMapGL.Marker(r.point);
        //         map.addOverlay(mk);
        //         map.panTo(r.point);
        //         // alert('您的位置是：' + r.point.lng + ',' + r.point.lat);
        //         console.log(r.point.lng + ',' + r.point.lat)
        //         // 创建地理编码实例      
        //         var myGeo = new BMapGL.Geocoder();
        //         // 开启SDK辅助定位
        //         geolocation.enableSDKLocation();
        //         // 根据坐标得到地址描述    
        //         myGeo.getLocation(new BMapGL.Point(r.point.lng, r.point.lat), function (result) {
        //             if (result) {
        //                 console.log(result)
        //                 setCity(result.addressComponents.city)
        //                 // alert(result.address);
        //                 getCityCode({
        //                     key: '322a406787446face1266fdd423482ba',
        //                     address: result.address
        //                 }).then(res => {
        //                     console.log(res)
        //                     setadCode(res.data.geocodes[0].adcode)
        //                 })

        //             }
        //         });
        //     }
        //     else {
        //         alert('failed' + this.getStatus());
        //     }
        // });
        getIp().then(res => {
            console.log(res.data.ad_info)
            setadCode(res.data.ad_info.adcode)
            setCity(res.data.ad_info.city)
        })
    }, [''])



    useEffect(() => {
        console.log('农历日期')
        setLunar(Lunar.fromDate(date).getMonthInChinese() + '月' + Lunar.fromDate(date).getDayInChinese())

        let a = document.getElementsByClassName('react-calendar__tile--active')[0].offsetTop
        console.log(a)
        setCalendarTop(a)

        if (!isSlide) {
            document.getElementsByClassName('react-calendar__month-view__days')[0].style.top = -a + 'px'
        }



    }, [date])

    //城市变化

    useEffect(() => {
        getCityWeather({
            key: '322a406787446face1266fdd423482ba',
            city: adCode
        }).then(res => {
            console.log('天气')
            console.log(res)
            setWeather(res.data.lives[0])
            console.log('天气')
        })
    }, [adCode])


    useEffect(() => {

        let a = document.getElementsByClassName('react-calendar__tile--active')[0].offsetTop
        setCalendarTop(a)
        document.getElementsByClassName('react-calendar__month-view__days')[0].style.top = -a + 'px'
        getNews()


        getJiJjian().then(res => {
            setJiJian(res.data)
        })

        getStock().then(res => {
            setStockList(res.data.data)
        })
        getTodayStock().then(res => {
            setTodayStock(res.data.list)
        })
        getHotRank().then(res => {
            console.log(res)
            setHotRank(res.data.data.ranks.slice(0, 3))
        })
        // console.log(a)
    }, [''])



    return (
        <div className='g-calendar'>
            {/* 顶部 */}


            {/* <div className='testcontrol'>
                <p onClick={() => { titleControl(true, true) }}>关闭隐藏拦</p><br />
                <p onClick={() => { titleControl(false, true) }}>开启隐藏拦</p><br />
                <p onClick={() => { titleControl(false, true) }}>关闭分享按钮</p><br />
                <p onClick={() => { titleControl(false, false) }}>开启分享按钮</p>
            </div> */}

            <div className='m-top'>
                <div className='u-date'>
                    <span className='u-year'>{date.getFullYear()}.{date.getMonth() + 1}</span>
                    <big className='u-day'>{date.getDate()}</big>
                    <span className='u-nongli'>{lunar}</span>
                    <span className='u-week'>{getWeek(date.getDay())}</span>
                </div>

                <div className='u-weather'>
                    <p className='u-temp'>
                        <span>{weather.temperature}</span>℃
                    </p>
                    <div className='u-weather-status'>
                        <div >
                            <WeatherIcon />
                            {weather.weather}
                        </div>
                        {/* <span className='u-air'>147 轻度污染</span> */}
                    </div>
                    <span className='u-city'>
                        {city}
                        {/* <img src={icon8} className='u-icon8' />  */}
                    </span>
                </div>

                <div className='u-mood'>
                    <div className='u-zhishu' onClick={() => { openLink('https://lianghua.nbd.com.cn/emotion4/data-dinner') }}>
                        <div className='u-zhishu-item' >
                            <div className='u-item-info'>{jiJian.zhishu}</div>
                            <div className='u-item-name'>极简指数</div>
                        </div>
                        <div className='u-zhishu-item'>
                            <div className='u-item-info' style={{ color: jiJian.qingxu.color }}>{jiJian.qingxu.name}</div>
                            <div className='u-item-name'>短期情绪</div>
                        </div>
                        <div className='u-zhishu-item'>
                            <div className='u-item-info u-blue'>{jiJian.fengge}</div>
                            <div className='u-item-name'>市场风格</div>
                        </div>
                    </div>

                    <div className='u-zhongqi'>
                        <span>中期趋势</span>
                        <span className='u-look-more-zhongqi' onClick={() => { openLink('https://lianghua.nbd.com.cn/emotion4/data-dinner') }}>点击查看 <img src={icon11} className='u-icon11' /> </span>
                    </div>

                    {
                        jiJian.status === 'NOT_PANZHONG' ?
                            <div className='u-stock' >
                                {/* <div className='u-stock-item'>
                                    <div className='u-item-info u-blue'>{jiJian.beixiang} <small>亿</small></div>
                                    <div className='u-item-name'>北向资金</div>
                                </div> */}
                                <div className='u-stock-item u-stock-item-full'>
                                    <div className='u-item-info'>
                                        <span className='u-red'>{jiJian.zhangDie.zhang}</span> : 
                                        <span className='u-gray'>{jiJian.zhangDie.ping}</span> : 
                                        <span className='u-green'>{jiJian.zhangDie.die}</span>
                                    </div>
                                    <div className='u-item-name'>个股涨跌</div>
                                </div>
                            </div>
                            :
                            <div className='u-stock' >
                                <div className='u-stock-item' onClick={() => { openLink('https://lianghua.nbd.com.cn/ipo_radar/index') }}>
                                    <div className='u-item-info u-blue'>{jiJian.shangshiCount}</div>
                                    <div className='u-item-name'>今日上市新股</div>
                                </div>
                                <div className='u-stock-item'>
                                    <div className='u-item-info u-blue'>{jiJian.jiejin.marketValue} <img src={jiJian.jiejin.upDown == 'DOWN' ? icon13 : icon12} className='u-icon12' /></div>
                                    <div className='u-item-name'>解禁股市值</div>
                                </div>
                            </div>
                    }




                </div>

            </div>
            {/* 股票指数 */}

            <div className='g-stock'>

                {
                    stockList?.map((item, index) => {
                        return (
                            <div className={item.fluctuationRange > 0 ? 'm-stock-item up' : 'm-stock-item down'} key={index} onClick={() => { openLink('https://lianghua.nbd.com.cn/emotionapp/zhishu/global') }}>
                                <p className='u-stock-name'>{item.symbol}</p>
                                <p className='u-stock-num'>{item.tradePrice}</p>
                                <p className='u-stock-roate'>
                                    <span> {item.fluctuation}</span>
                                    <span> {item.fluctuationRange}%</span>
                                </p>
                            </div>
                        )
                    })
                }
                <div className='u-stock-more' onClick={() => { openLink('https://lianghua.nbd.com.cn/emotionapp/zhishu/global') }}>
                    更 多
                </div>


            </div>

            {/* 每经热榜 */}

            <div className='g-hot-news'>

                {
                    hotRank.map((item, index) => {
                        return (
                            <div className='m-news'>
                                <img src={item.icon.replace('http', 'https')} className='u-rank-icon' />
                                <a href='javascript:void(0)' className='u-rank-title' onClick={() => { openLink(item.link) }}>{item.title}</a>
                            </div>
                        )
                    })
                }

                <img src={icon15} className='u-icon15' onClick={() => { openLink('http://www.nbd.com.cn/corp/20220801hotTop/dist/#/') }} />


            </div>


            {/* 日历 */}
            <div className='g-calendar-box'>
                <div className={isSlide ? 'm-calendar slide-down' : 'm-calendar slide-up'}>
                    <Calendar onChange={changeDate} value={date} maxDetail={'month'} formatShortWeekday={(locale, value) => ['日', '一', '二', '三', '四', '五', '六'][value.getDay()]}
                        formatLongDate={(locale, value) => value.getDate()}
                    />

                </div>
                <div className='toggle-calendar'  >
                    <img src={icon6} className={isSlide ? 'u-icon6 down' : 'u-icon6 '} onClick={changeSlide} />
                </div>

            </div>

            <div className='g-tag'>
                <div className='m-tab'>
                    {
                        tabList.map((item, index) => {
                            return (
                                <span onClick={() => { switchInex(index) }} key={index} className={index == activeIndex ? 'active' : ''}> {item} <i></i> </span>
                            )
                        })
                    }
                </div>
            </div>


            {
                activeIndex == 0 ?
                    <NewsList list={newsList} />
                    :
                    <Personal stockList={todayStock} date={date} />
            }



            {/* 底部 */}
            <div className={isApp ? 'g-bottom-nav' : 'g-bottom-nav hidden'}>
                <div onClick={() => { isShow(true) }}>
                    <img src={icon9} />
                    图片预览
                </div>
                <div onClick={shareInfo}>
                    <img src={icon10} />
                    分享链接
                </div>
            </div>




            {/* 地图组件服务 */}
            <div id='container'></div>


            {/* 生成图片 */}
            <div className={isShowLayer ? 'g-layer' : 'g-layer hidden'}>

                <div className="m-layer-content" id='bg'>
                    <img src={layer_bg} className='u-layer_bg' />
                    <div className='u-previewDateBox'>
                        <div className='u-previewDate'>
                            <span className='u-preview-month'>
                                {new Date().getMonth() + 1}
                            </span>

                            <span>
                                /
                            </span>
                            <span className='u-preview-date'>
                                {new Date().getDate()}
                            </span>

                        </div>
                        <div className='u-previewYear'>
                            <span className='u-preview-year'>
                                {new Date().getFullYear()}
                            </span>
                            <span className='u-preview-week'>
                                {getWeek(date.getDay())}
                            </span>
                        </div>


                    </div>
                    <div className="m-layer-preview">

                        {/* 顶部 */}
                        <div className='m-preview-top'>
                            <div className='m-top'>
                                <div className='u-date'>
                                    <span className='u-year'>{date.getFullYear()}.{date.getMonth() + 1}</span>
                                    <big className='u-day'>{date.getDate()}</big>
                                    <span className='u-nongli'>{lunar}</span>
                                    <span className='u-week'>{getWeek(date.getDay())}</span>

                                    <div className='u-line1'></div>
                                </div>

                                <div className='u-weather'>
                                    <p className='u-temp'>
                                        <span>{weather.temperature}</span>℃
                                    </p>
                                    <div className='u-weather-status'>
                                        <div >
                                            <WeatherIcon />
                                            {weather.weather}
                                        </div>
                                        {/* <span className='u-air'>147 轻度污染</span> */}
                                    </div>
                                    <span className='u-city'>
                                        {city}
                                        {/* <img src={icon8} className='u-icon8' />  */}
                                    </span>
                                    <div className='u-line1 u-right2'></div>
                                </div>

                                <div className='u-mood'>
                                    <div className='u-zhishu' onClick={() => { openLink('https://lianghua.nbd.com.cn/emotion4/data-dinner') }}>
                                        <div className='u-zhishu-item' >
                                            <div className='u-item-info'>{jiJian.zhishu}</div>
                                            <div className='u-item-name'>极简指数</div>
                                        </div>
                                        <div className='u-zhishu-item'>
                                            <div className='u-item-info' style={{ color: jiJian.qingxu.color }}>{jiJian.qingxu.name}</div>
                                            <div className='u-item-name'>短期情绪</div>
                                        </div>
                                        <div className='u-zhishu-item'>
                                            <div className='u-item-info u-blue'>{jiJian.fengge}</div>
                                            <div className='u-item-name'>市场风格</div>
                                        </div>
                                    </div>

                                    <div className='u-zhongqi'>
                                        <span>中期趋势</span>
                                        {/* <span className='u-look-more-zhongqi' onClick={() => { openLink('https://lianghua.nbd.com.cn/emotion4/data-dinner') }}>点击查看 <img src={icon11} className='u-icon11' /> </span> */}
                                    </div>

                                    {
                                        jiJian.status === 'NOT_PANZHONG' ?
                                            <div className='u-stock' >
                                                <div className='u-stock-item'>

                                                    <div className='u-item-info u-blue'>{jiJian.beixiang} <small>亿</small></div>



                                                    <div className='u-item-name'>北向资金</div>
                                                </div>
                                                <div className='u-stock-item'>
                                                    <div className='u-item-info'>
                                                        <span className='u-red'>{jiJian.zhangDie.zhang}</span>:
                                                        <span className='u-gray'>{jiJian.zhangDie.ping}</span>:
                                                        <span className='u-green'>{jiJian.zhangDie.die}</span>
                                                    </div>
                                                    <div className='u-item-name'>个股涨跌</div>
                                                </div>
                                            </div>
                                            :
                                            <div className='u-stock' >
                                                <div className='u-stock-item' onClick={() => { openLink('https://lianghua.nbd.com.cn/ipo_radar/index') }}>
                                                    <div className='u-item-info u-blue'>{jiJian.shangshiCount}</div>
                                                    <div className='u-item-name'>今日上市新股</div>
                                                </div>
                                                <div className='u-stock-item'>
                                                    <div className='u-item-info u-blue'>{jiJian.jiejin.marketValue} <img src={jiJian.jiejin.upDown == 'DOWN' ? icon13 : icon12} className='u-icon12' /></div>
                                                    <div className='u-item-name'>解禁股市值</div>
                                                </div>
                                            </div>
                                    }




                                </div>

                            </div>
                        </div>

                        <div className='m-preview-news-content'>
                            <img src={icon20} className='u-icon20' />
                            <div className='m-box'>
                                <p className='u-preview-title'>
                                    每经热榜
                                </p>
                                <div className='u-preview-content'>
                                    {
                                        hotRank.map((item, index) => {
                                            return (
                                                <div className='m-news'>
                                                    <img src={require('../img/rank' + Number(index + 1) + '.png')} className='u-rank-icon' />
                                                    <a href='javascript:void(0)' className='u-rank-title' onClick={() => { openLink(item.link) }}>{item.title}</a>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                            </div>
                            <div className='u-border-bootom'></div>
                            <div className='m-box'>
                                <p className='u-preview-title'>
                                    当日大事
                                </p>
                                <div className='u-preview-content'>
                                    {
                                        newsList.length > 0 ?
                                            newsList.slice(0, 7).map((item, index) => {
                                                return (
                                                    <div className='m-preview-big-news'>
                                                        <span>
                                                            {index + 1}
                                                        </span>
                                                        <p>
                                                            {item.title}
                                                        </p>
                                                    </div>
                                                )
                                            })
                                            :
                                            <Nodata />
                                    }
                                </div>

                            </div>
                        </div>
                        <img src={layer_bottom} className="u-layer-bottom" />
                    </div>

                </div>

                <div className='u-control-flex'>
                    <div className='u-create-img u-blue-bg' onClick={canvasImg}>
                        生成图片
                    </div>
                    <div className='u-create-img' onClick={() => { isShow(false) }}>
                        关闭
                    </div>
                </div>






            </div>

            {/* 图片生成 */}

            <div className={startImg ? 'g-layer' : 'g-layer hidden'}>
                <img src={previewImg} className="u-previewImg" />
                <p className='u-hint' >
                    长按图片保存或分享
                </p>
                <div className='u-create-img' onClick={closeImg}>
                    关闭
                </div>
            </div>

        </div>
    )
}
export default Newcalendar